"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

require("core-js/modules/es.array.reduce.js");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_fast_compare_1 = __importDefault(require("react-fast-compare"));

var lodash_1 = require("lodash");

var slate_1 = require("slate");

var slate_react_1 = require("slate-react");

var mobx_react_lite_1 = require("mobx-react-lite");

var core_1 = require("@bodiless/core");

var fclasses_1 = require("@bodiless/fclasses");

var slate_history_1 = require("slate-history");

var core_2 = require("./core");

var withNodeStateHandlers_1 = __importDefault(require("./withNodeStateHandlers"));

var RichTextItemGetters_1 = require("./RichTextItemGetters");

var useKeyBoardShortcuts_1 = __importDefault(require("./useKeyBoardShortcuts"));

var TextSelectorButton_1 = __importDefault(require("./components/TextSelectorButton"));

var RichTextContext_1 = require("./RichTextContext");

var meta_1 = require("./meta");

var withDefaults_1 = __importDefault(require("./withDefaults"));

var RichTextPreview_1 = require("./RichTextPreview");

var withDataMigrator_1 = __importDefault(require("./withDataMigrator"));

var withHtmlPaste_1 = __importDefault(require("./withHtmlPaste"));

var useInitialValue_1 = __importDefault(require("./useInitialValue")); // Addes a schema prop and hten adds that value to the slate context.


var withSlateSchema = function withSlateSchema(Component) {
  return function (props) {
    var schema = props.schema,
        rest = __rest(props, ["schema"]);

    var slateContext = core_2.useSlateContext();
    var editorProps = slateContext.editorProps;

    var updatedSlateContext = __assign(__assign({}, slateContext), {
      editorProps: __assign(__assign({}, editorProps), {
        schema: schema
      })
    });

    return react_1.default.createElement(core_2.SlateEditorContext.Provider, {
      value: updatedSlateContext
    }, react_1.default.createElement(Component, __assign({}, rest)));
  };
}; // create item to activate the context not sure whats up with all the old vs new


var withSlateActivator = function withSlateActivator(Component) {
  return function (props) {
    var previousSlateContext = core_2.useSlateContext();
    var previousEditorProps = previousSlateContext.editorProps; // TODO: The following onCHange handler is only necessary if the menu options provided
    // by this editor depend on the state of the editor. If this is ever the case, we will
    // need to add logic to prevent the context from refreshing on *every* change, and
    // only trigger refresh when necxessary.
    // NOTE: As of this commit, refresh has been deprecated, and this may no longer
    // be necessary.
    // const context = useEditContext();
    // tslint:disable-next-line: ter-arrow-parens
    // const onChange: BasicEditorProps['onChange'] = change => {
    //   if (typeof previousEditorProps.onChange === 'function' && change) {
    //     previousEditorProps.onChange(change);
    //   }
    //   context.refresh();
    // };

    var editorProps = __assign(__assign({}, previousEditorProps), core_1.useContextActivator());

    var slateContext = __assign(__assign({}, previousSlateContext), {
      editorProps: __assign(__assign({}, previousSlateContext === null || previousSlateContext === void 0 ? void 0 : previousSlateContext.editorProps), editorProps)
    });

    return react_1.default.createElement(core_2.SlateEditorContext.Provider, {
      value: slateContext
    }, react_1.default.createElement(Component, __assign({}, props)));
  };
}; // This is a call back that goes to withMenuOptions so that we can add button to the global menu


var useMenuOptions = function useMenuOptions(props) {
  var editor = slate_react_1.useSlate();
  return react_1.useMemo(function () {
    return props.globalButtons ? props.globalButtons(editor) : [];
  }, [props.globalButtons]);
};

var ifMenuOptions = core_1.ifToggledOn(function (props) {
  var context = core_1.useEditContext();
  return context.isEdit && Boolean(props.globalButtons);
});
var RichTextProvider = lodash_1.flowRight(fclasses_1.withDisplayName('RichTextProvider'), core_2.withSlateEditor, ifMenuOptions(core_1.withMenuOptions({
  useMenuOptions: useMenuOptions,
  name: 'editor'
}), withSlateActivator), withSlateSchema)(fclasses_1.Fragment);
/**
 * @private
 * Observer wrapper around hover menu which hides it when not in edit mode.
 */

var EditOnlyHoverMenu$ = function EditOnlyHoverMenu$(_a) {
  var HoverMenu = _a.HoverMenu,
      children = _a.children;
  var isEdit = core_1.useEditContext().isEdit;
  return isEdit ? react_1.default.createElement(HoverMenu, null, children) : react_1.default.createElement(react_1.default.Fragment, null);
};

var EditOnlyHoverMenu = mobx_react_lite_1.observer(EditOnlyHoverMenu$);

var withEditorSettings = function withEditorSettings(components) {
  return function (editor) {
    var isInline = editor.isInline;
    var inlineTypes = RichTextItemGetters_1.getInlineButtons(components).map(function (Component) {
      return Component.id;
    }); // eslint-disable-next-line no-param-reassign

    editor.isInline = function (element) {
      return inlineTypes.includes(element.type) ? true : isInline(element);
    };

    return editor;
  };
};

var BasicRichText = react_1.default.memo(function (props) {
  var initialValue = props.initialValue,
      components = props.components,
      ui = props.ui,
      onChange = props.onChange,
      value = props.value,
      rest = __rest(props, ["initialValue", "components", "ui", "onChange", "value"]);

  var _a = react_1.useMemo(function () {
    var finalComponents$ = withDefaults_1.default(components);
    return {
      finalComponents: finalComponents$,
      plugins: RichTextItemGetters_1.getPlugins(finalComponents$),
      globalButtons: RichTextItemGetters_1.getGlobalButtons(finalComponents$)
    };
  }, [components]),
      finalComponents = _a.finalComponents,
      plugins = _a.plugins,
      globalButtons = _a.globalButtons;

  var HoverMenu = RichTextContext_1.getUI(ui).HoverMenu;
  var finalUI = RichTextContext_1.getUI(ui);
  var selectorButtons = RichTextItemGetters_1.getSelectorButtons(finalComponents).map(function (C) {
    return react_1.default.createElement(C, {
      key: core_1.useUUID()
    });
  });
  var editor = react_1.useRef(lodash_1.flow(slate_react_1.withReact, slate_history_1.withHistory, withEditorSettings(finalComponents), withHtmlPaste_1.default(finalComponents))(slate_1.createEditor()));
  var initialValue$ = useInitialValue_1.default(initialValue);
  var value$ = value !== undefined && !lodash_1.isEmpty(value) ? value : initialValue$;
  return react_1.default.createElement(slate_react_1.Slate, {
    editor: editor.current,
    value: value$,
    onChange: onChange
  }, react_1.default.createElement(RichTextContext_1.uiContext.Provider, {
    value: finalUI
  }, react_1.default.createElement(RichTextProvider, __assign({}, rest, {
    initialValue: initialValue$,
    plugins: plugins,
    globalButtons: globalButtons
  }), react_1.default.createElement(EditOnlyHoverMenu, {
    HoverMenu: HoverMenu
  }, RichTextItemGetters_1.getHoverButtons(finalComponents).map(function (C) {
    return react_1.default.createElement(C, {
      key: core_1.useUUID()
    });
  }), selectorButtons.length > 0 && react_1.default.createElement(TextSelectorButton_1.default, null, selectorButtons)), react_1.default.createElement(core_2.Content, __assign({}, useKeyBoardShortcuts_1.default({
    editor: editor.current,
    components: finalComponents
  }), rest)))));
}, function (prevProps, nextProps) {
  return react_fast_compare_1.default(prevProps.value, nextProps.value);
});
var defaults = {
  SuperScript: fclasses_1.Sup,
  Bold: fclasses_1.B,
  Italic: fclasses_1.Em,
  Underline: fclasses_1.Span,
  Link: fclasses_1.A,
  AlignLeft: fclasses_1.Div,
  AlignRight: fclasses_1.Div,
  AlignCenter: fclasses_1.Div,
  AlignJustify: fclasses_1.Div,
  H1: fclasses_1.H1,
  H2: fclasses_1.H2,
  H3: fclasses_1.H3
};
var lastDesign = {
  SuperScript: meta_1.withSuperScriptMeta,
  Bold: meta_1.withBoldMeta,
  Italic: meta_1.withItalicMeta,
  Underline: meta_1.withUnderlineMeta,
  Link: meta_1.withLinkMeta,
  AlignLeft: meta_1.withAlignLeftMeta,
  AlignRight: meta_1.withAlignRightMeta,
  AlignCenter: meta_1.withAlignCenterMeta,
  AlignJustify: meta_1.withAlignJustifyMeta,
  H1: meta_1.withHeader1Meta,
  H2: meta_1.withHeader2Meta,
  H3: meta_1.withHeader3Meta
}; // Build an apply function that will only use components where we have a shared key in the design
// as well as only apply the finalDesign on items that are already in the design.

var apply = function apply(design) {
  // We want to add our meta data if the keys are present.
  var start = Object.getOwnPropertyNames(design).reduce(function (acc, key) {
    var _a;

    return __assign(__assign({}, acc), (_a = {}, _a[key] = Object.prototype.hasOwnProperty.call(defaults, key) ? defaults[key] : fclasses_1.Span, _a));
  }, {});
  var finalDesign = lodash_1.pick(lastDesign, Object.getOwnPropertyNames(design));
  return fclasses_1.applyDesign(start)(fclasses_1.extendDesign(finalDesign)(design));
};

var RichText = lodash_1.flow(withDataMigrator_1.default, withNodeStateHandlers_1.default, core_1.withNode, RichTextPreview_1.withPreview, fclasses_1.designable(apply, 'RichText'))(BasicRichText);
exports.default = RichText;